<template>
  <div class="workpackage-on-site-info-container">
    <!-- TODO:
         scrollbars are hidden, but there are actually two;
         one for the router view and one for view inside
         we need to get rid of SubpageHeader.module.vue space!
    -->
    <div
      class="workpackage-on-site-info-router"
      :style="`fill: ${workpackage_fg_hex}; position: relative`"
    >
      <router-view />
    </div>
    <div class="workpackage-on-site-info-bottom-navigation">
      <div class="workpackage-on-site-info-list-container">
        <div
          class="workpackage-on-site-info-step-type-list"
          :style="`
            max-height: ${!is_expand_steps ? widget_min_height : step_type_max_height}px;
            grid-gap: ${grid_gap}px;
          `"
        >
          <CircularProgressButton
            v-for="(progress_btn, index) in progress_buttons"
            :key="`collapsed:${progress_btn.step_type}${index}`"
            :icon="$store.state.Ultra.step_icons[progress_btn.step_type.toLowerCase()]"
            :value="getCollapsedProgressValue(progress_btn.progress.done_count, progress_btn.progress.task_count)"
            :has_no_tasks="progress_btn.progress.task_count === 0"
            :is_disabled="false"
            :width="4"
            :items_per_row="items_per_row"
            :is_marked="cached_step_type == progress_btn.step_type"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @emittedClick="$router.push({name: `${location}WorkPackage${progress_btn.step_type}Steps`, params: { nav_back: $route.params.nav_back} }), cached_step_type = progress_btn.step_type"
          />
        </div>
        <div class="workpackage-on-site-expand-list" :style="`max-height: ${!is_expand_widgets ? widget_min_height : step_type_max_height}px;`">
          <div class="workpackage-on-site-expand-step-type-button-container">
            <button
              class="workpackage-on-site-expand-step-type-button"
              :style="`border-color: ${getTranspHexColor(workpackage_fg_hex, 0.5)};`"
              :is_active="is_expand_steps"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @click="is_expand_steps = !is_expand_steps"
            >
              <TIcon name="chevron-up" :color="workpackage_fg_hex" large :style="is_expand_steps ? 'transform: rotate(-180deg);' : ''" />
            </button>
          </div>
        </div>
      </div>

      <div class="workpackage-on-site-info-list-container">
        <div
          class="workpackage-on-site-info-widget-list"
          :style="`
            max-height: ${!is_expand_widgets ? widget_min_height : widget_max_height}px;
            grid-gap: ${grid_gap}px;
          `"
        >
          <RadioButtonSquare
            v-for="(widget, index) in widgets"
            :key="`${widget.step_name}${index}`"
            :id="`${widget.text}${index}`"
            :is_active="is_active(widget)"
            :is_badge="widget.is_badge"
            :is_disabled="widget.is_disabled"
            :badge_width="16"
            :items_per_row="items_per_row"
            :background_color="workpackage_bg_hex"
            :foreground_color="workpackage_fg_hex"
            @setActive="$router.push({
                name: $route.name.includes(widget.route_name)
                  ? `${location}WorkPackage${cached_step_type}Steps`
                  : `${location}${widget.route_name}`,
                params: { nav_back: $route.params.nav_back} })"
          >
            <template #content>
              <div class="workpackage-on-site-info-widget-list-content">
                <TIcon
                  :name="widget.icon"
                  style="transition: none"
                />
                <TText
                  :text="widget.text"
                  :color="is_active(widget)
                    ? workpackage_bg_hex
                    : workpackage_fg_hex"
                  :size="8"
                />
              </div>
            </template>
          </RadioButtonSquare>
        </div>
        <div
          class="workpackage-on-site-expand-list"
          :style="`
            max-height: ${!is_expand_widgets ? widget_min_height : widget_max_height}px;
            grid-gap: ${grid_gap}px;
          `"
        >
          <div
            id="widget-height"
            class="workpackage-on-site-expand-widget-button-container"
          >
            <RadioButtonSquare
              class="workpackage-on-site-expand-widget-button"
              :is_active="is_expand_widgets"
              :width="widget_min_height"
              :background_color="workpackage_bg_hex"
              :foreground_color="workpackage_fg_hex"
              @setActive="is_expand_widgets = !is_expand_widgets"
            >
              <template #content>
                <div>
                  <TIcon
                    name="horizontal-dots"
                    style="transition: none"
                  />
                  <TText
                    text="More"
                    :color="is_expand_widgets
                      ? workpackage_bg_hex
                      : workpackage_fg_hex
                    "
                    :size="8"
                  />
                </div>
              </template>
            </RadioButtonSquare>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import { mapGetters, mapActions } from 'vuex';
import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
import { BacklogMixin } from '@/mixins/Backlog.mixin.js'
import { TColor } from '@/mixins/TColor.mixin.js'

import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import RadioButtonSquare from '@/components/WorkPackageWIP/RadioButtonSquare.component.vue';
import CircularProgressButton from '@/components/WorkPackageWIP/CircularProgressButton.component.vue';

  export default {
    components: {
      TText,
      TIcon,
      RadioButtonSquare,
      CircularProgressButton,
    },

    mixins: [
      WorkPackageReworkMixin,
      BacklogMixin,
      TColor,
    ],

    props: [
      'location',
      'prefix',
      'backlog'
    ],

    data: () => ({
      widget_min_height: 0,
      widget_max_height: 0,
      step_type_max_height: 0,
      cached_step_type: 'Work',
      items_per_row: 4,
      grid_gap: 4,

      selected_day: 'Mo',
      update_additional_info: 0,
      show_date_picker: false,
      is_expand_steps: false,
      is_expand_widgets: false,
    }),

    created() {
      let self = this;
      if (this.location !== 'HistProjectTaktPlan') {
        this.initializeSelectedDay();
      }
      store.dispatch('UltraDev/updateUDObject', {
        url: this.workpackage_url,
        update: { is_open: true }
      });
      this.requestUObject({
        url: this.workpackage_url,
        url_suffix: '/additionalinformation'
      }).then(() => {
        self.update_additional_info++;
      });
    },

    mounted() {
      // NOTE: these need to be set on mount and on resize
      this.calcListMinMax();
      window.addEventListener('resize', this.calcListMinMax);
    },

    watch: {
      workpackage_id(val, old_val) {
        if (this.location !== 'HistProjectTaktPlan') {
          this.initializeSelectedDay();
        }
        let update_url_val = JSON.parse(JSON.stringify(this.workpackage_url));
        let update_url_old_val = JSON.parse(JSON.stringify(this.workpackage_url));

        update_url_val[update_url_val.length-1][`${this.histprefix}${this.prefix}workpackages`] = val;
        update_url_old_val[update_url_old_val.length-1][`${this.histprefix}${this.prefix}workpackages`] = old_val;

        store.dispatch('UltraDev/updateUDObject', {
          url: update_url_val,
          update: { is_open: true }
        });
        store.dispatch('UltraDev/updateUDObject', {
          url: update_url_old_val,
          update: { is_open: false }
        });

        this.requestUObject({
          url: update_url_val,
          url_suffix: '/additionalinformation'
        }).then(() => {
          self.update_additional_info++;
        });
      }
    },

    beforeRouteLeave(to, from, next) {
      window.removeEventListener('resize', this.calcListMinMax);
      store.dispatch('UltraDev/updateUDObject', {
        url: this.workpackage_url,
        update: { is_open: false }
      });
      next();
    },

    computed: {
      ...mapGetters('Ultra', [
        'getUObjectsFiltered',
        'getUObjects'
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
        'hasProjectPermission',
      ]),
      ...mapGetters('ProjectCalendar', [
        'getCalendar',
        'getWeekDaysSorted',
        'hasCalendar',
      ]),

      progress_buttons() {
        // NOTE: get these from a store
        return [
          {
            step_type: 'Logistic',
            progress: this.calcStepProgress('logistic')
          },
          {
            step_type: 'Design',
            progress: this.calcStepProgress('design')
          },
          {
            step_type: 'Work',
            progress: this.calcStepProgress('work')
          },
          {
            step_type: 'Quality',
            progress: this.calcStepProgress('quality')
          },
          {
            step_type: 'Defect',
            progress: this.calcStepProgress('defect')
          },
          {
            step_type: 'Handover',
            progress: this.calcStepProgress('handover')
          },
          {
            step_type: 'Material',
            progress: this.calcStepProgress('material')
          },
        ]
      },

      widgets() {
        // NOTE: move these to a store
        return [
          { icon: 'camera-simple', text: this.$t('WorkpackageRework.Info.Camera.Header'), route_name: 'WorkPackageCamera', is_disabled: false },
          { icon: 'image', text: this.$t('WorkpackageRework.Info.Images.Header'), route_name: 'WorkPackageImages', is_disabled: false },
          { icon: 'qr-code', text: 'QR-Codes', route_name: 'WorkPackageQRCodes', is_disabled: false },
          { icon: 'person', text: this.$t('WorkpackageRework.Info.Contacts.Header'), route_name: 'WorkPackageContacts', is_disabled: false },
          { icon: 'money-bill', text: this.$t('WorkpackageRework.Info.Costs.Header'), route_name: 'WorkPackageCosts'},
          { icon: 'pencil', text: this.$t('WorkpackageRework.Info.Log.Header'), route_name: 'WorkPackageLogList', is_disabled: false },
          { icon: 'info', text: 'Info' /*TODO: Translate*/, route_name: 'WorkPackageAdditionalInformation', is_disabled: false },
          { icon: 'steering-wheel', text: 'Autopilots' /*TODO: Translate*/, route_name: 'WorkPackageAutopilots', is_disabled: false },
          { icon: 'time-effort', text: 'Time Effort' /* TODO: Translate*/, route_name: 'WorkPackageTimeRecord', is_disabled: false },
        ];
      },

      histprefix(){
        if (this.location === 'HistProjectTaktPlan') {
          return 'hist';
        }
        return '';
      },

      taktarea() {
        return this.$store.state.Ultra[`${this.histprefix}taktareas`][this.taktarea_id];
      },

      wbline() {
        return this.$store.state.Ultra[`${this.histprefix}wblines`][this.wbline_id];
      },

      mobile_height() {
        return window.innerHeight;
      },

      daily_report_days() {
        if (this.location === 'HistProjectTaktPlan') {
          return [];
        }
        let days = [];
        let week_days_sorted = this.getWeekDaysSorted(this.project_id);
        week_days_sorted.forEach(day => {
          days.push({description: day, is_disabled: true, takt_date: ''})
        });
        days = days.concat([
          {is_invisible: true, is_disabled: true},
          {is_invisible: true, is_disabled: true},
          {description: 'TAKT', takt_date: ''}
        ]);
        if (this.hasCalendar(this.project_id)) {
          let index = this.$store.state.Ultra.trains[this.train_id].train_start + this.taktarea.taktarea_start + this.taktarea.twaggons.indexOf(parseInt(this.twaggon_id));
          let calendar = this.getCalendar(this.project_id);
          if (index !== -1) {
            calendar.takt_times[index].dates.forEach(date => {
              let name = this.$store.state.Ultra.week_days[date.getDay()];
              let day = days.find(day => day.description === name);
              day.is_disabled = false
              day.takt_date = date.toISOString().substring(0,10);
            });
          }
        }
        return days;
      },

      selected_report() {
        if (this.selected_day !== 'TAKT') {
          let selected_takt_date = this.daily_report_days.find(day => day.description === this.selected_day).takt_date;
          let reports = JSON.parse(JSON.stringify(this.getUObjectsFiltered({type: 'dailyreports', ids: this.workpackage.dailyreports, search: {date: selected_takt_date}})));
          if (reports.length !== 0) {
            reports[0].time_effort = reports[0].manpower * reports[0].duration;
            return reports[0];
          } else {
            // no record created
            return {
              manpower: 0,
              duration: 0,
              time_effort: 0,
              date: selected_takt_date,
              create: true,
            };
          }
        } else {
          let takt_report = {
            manpower: 0,
            duration: 0,
            time_effort: 0,
            date: 'TAKT'
          }
          let dailyreports = this.getUObjects({type: 'dailyreports', ids: this.workpackage.dailyreports});
          dailyreports.forEach(report => {
            takt_report.manpower += report.manpower;
            takt_report.duration += report.duration;
            takt_report.time_effort += (report.manpower * report.duration);
          });
          if (dailyreports.length !== 0) {
            takt_report.manpower = Math.round((takt_report.manpower / dailyreports.length)*100)/100;
          } else {
            takt_report.manpower = 0;
          }
          return takt_report;
        }
      }
    },

    methods: {
      ...mapActions('Ultra', [
        'updateUObject',
        'requestUObject',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarUpdate'
      ]),
      ...mapActions('UltraDev', [
        'updateUDObject',
      ]),
      ...mapActions('WorkPackageLogList', [
        'createLogListComment',
      ]),

      is_active(widget){
        // NOTE: a better solution is welcomed
        return this.$route.name.includes(widget.route_name) && !this.$route.path.includes('step');
      },

      calcListMinMax() {
        this.widget_min_height = Math.floor(document.getElementById('widget-height').scrollHeight);

        let row_count;
        row_count = this.widgets.length / this.items_per_row + 1;
        this.widget_max_height = row_count * (this.widget_min_height) + (row_count - 1) * this.grid_gap;

        row_count = this.progress_buttons.length / this.items_per_row + 1;
        this.step_type_max_height = row_count * (this.widget_min_height) + (row_count - 1) * this.grid_gap;
      },

      getCollapsedProgressValue(done_count, task_count) {
        if(task_count <= 0) { // if there are no tasks at all
          return 0; // this is necessary cause either we divide by 0 or task_count was faulty to begin with
        }

        let done = parseInt(done_count);
        let tasks = parseInt(task_count);
        let progress = parseInt((done / tasks) * 100);

        return progress;
      },

      log(evt) {
        console.log(evt);
      },

      calcStepProgress(step_type) {
        return {
          done_count: this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`].length !== 0?
            this.getUObjectsFiltered({type: `${this.histprefix}${this.prefix}${step_type}steps`, ids: this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`], filter: {done: true}}).length
            :(
            this.workpackage[`${this.prefix}${step_type}steps_done_count`]?
            this.workpackage[`${this.prefix}${step_type}steps_done_count`]
            :
            0),
          task_count: this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`].length === 0?
            this.workpackage[`${this.prefix}${step_type}_step_count`]
            :
            this.workpackage[`${this.histprefix}${this.prefix}${step_type}steps`].length
          };
      },

      handleCheckBoxClicked(origin) {
        let tmp = this.checkboxes.find(element => element.id == origin);
        tmp.is_checked = !tmp.is_checked;
      },

      initializeSelectedDay() {
          if (this.hasCalendar(this.project_id) && !this.backlog) {
            let index = this.$store.state.Ultra.trains[this.train_id].train_start + this.taktarea.taktarea_start + this.taktarea.twaggons.indexOf(parseInt(this.twaggon_id));
            if (index !== -1) {
              let today = new Date().toISOString().substring(0,10);
              let day = this.daily_report_days.find(day => day.takt_date === today);
              if (day) {
                this.selected_day = day.description;
              } else {
                this.selected_day = this.daily_report_days.filter(day => !day.is_disabled && day.description !== 'TAKT')[0].description;
              }
            }
          }
      },

      changeDailyReport(payload) {
        if (this.selected_report.create) {
          let report = {
            manpower: 0,
            duration: 0,
            date: this.selected_report.date
          }
          report[payload.prop] = payload.value;
          this.createUObject({
            url: [
              {projects: this.project_id},
              {trains: this.train_id},
              {taktareas: this.taktarea_id},
              {twaggons: this.twaggon_id},
              {tworkpackages: this.workpackage_id},
              {dailyreports: ''},
              {showWithEntitiesNormalized: ''}
            ],
            u_object: report
          })
        } else if (this.selected_report.date !== 'TAKT') {
          this.updateUObject({
            url: [
              {projects: this.project_id},
              {trains: this.train_id},
              {taktareas: this.taktarea_id},
              {twaggons: this.twaggon_id},
              {tworkpackages: this.workpackage_id},
              {dailyreports: this.selected_report.id}
            ],
            update: {
              [payload.prop]: payload.value
            }
          })
        } else {
          let dailyreports = this.getUObjects({type: 'dailyreports', ids: this.workpackage.dailyreports});
          let daily_report_days_filtered = JSON.parse(JSON.stringify(this.daily_report_days.filter(day => !day.is_disabled && day.description !== 'TAKT')));
          daily_report_days_filtered.forEach(day => {
              let daily_report = dailyreports.find(report => report.date.includes(day.takt_date));
              if (daily_report) {
                this.updateUObject({
                  url: [
                    {projects: this.project_id},
                    {trains: this.train_id},
                    {taktareas: this.taktarea_id},
                    {twaggons: this.twaggon_id},
                    {tworkpackages: this.workpackage_id},
                    {dailyreports: daily_report.id}
                  ],
                  update: {
                    [payload.prop]: payload.prop === 'duration'?(payload.value / daily_report_days_filtered.length):payload.value
                  }
                })
              } else {
                let report = {
                  manpower: 0,
                  duration: 0,
                  date: day.takt_date
                }
                report[payload.prop] = payload.prop === 'duration'?(payload.value / daily_report_days_filtered.length):payload.value;
                this.createUObject({
                  url: [
                    {projects: this.project_id},
                    {trains: this.train_id},
                    {taktareas: this.taktarea_id},
                    {twaggons: this.twaggon_id},
                    {tworkpackages: this.workpackage_id},
                    {dailyreports: ''},
                    {showWithEntitiesNormalized: ''}
                  ],
                  u_object: report
                })
              }
          });
        }
      },
    },
  }
</script>
<!-- .workpackage-on-site-info-router {
  flex-grow: 1;
  overflow: auto;
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}
.workpackage-on-site-info-router::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}
.workpackage-on-site-info-widget-list::-webkit-scrollbar, .workpackage-on-site-info-step-type-list::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
} -->
<style>
.workpackage-on-site-info-container {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  height: 100%;
}
.workpackage-on-site-info-router {
  flex-grow: 1;
  overflow: auto;
}
.workpackage-on-site-info-list-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0 8px;
  z-index: 1000;
}
.workpackage-on-site-info-widget-list, .workpackage-on-site-info-step-type-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  flex-grow: 1;
  transition: max-height 0.2s ease-in-out;
}
.workpackage-on-site-info-widget-list-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.workpackage-on-site-info-bottom-navigation {
  z-index: 1000;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.workpackage-on-site-expand-list {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: center;
  width: calc(100% / 5 - 5px);
}
.workpackage-on-site-expand-widget-button-container {
  width: 100%;
  aspect-ratio: 1 / 1;
}
.workpackage-on-site-expand-widget-button {
  width: 100%;
  height: 100%;
}
.workpackage-on-site-expand-step-type-button-container {
  width: 100%;
  aspect-ratio: 1 / 1;
  margin: 4px;
}
.workpackage-on-site-expand-step-type-button {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid;
  border-radius: 50%;
}
.appear-enter-active, .appear-leave-active {
  transition: all 0.5s ease-in-out;
}
.appear-enter, .appear-leave-to {
  opacity: 0;
}
.subage-slide-in-enter-active, .subage-slide-in-leave-active {
  transition: all 0.25s ease-in-out;
}
.subage-slide-in-enter, .subage-slide-in-leave-to {
  transform: translateX(100%);
}
</style>
